import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'aw-error-message',
  imports: [CommonModule],
  templateUrl: './error-message.component.html',
  styles: [
    `
      .error-wrapper:not(:empty) {
        padding-top: 0.5rem;
      }
    `,
  ],
})
export class ErrorMessageComponent {}
